const SMALL_VIEWPORT_QUERY = '(max-width: 1024px)';

export const pickLazyBg = (el: HTMLElement): string | undefined => {
    const small = el.dataset['bgMd'];
    const full = el.dataset['bg'];
    if (small && window.matchMedia(SMALL_VIEWPORT_QUERY).matches) {
        return small;
    }
    return full;
};

export const applyLazyBg = (el: HTMLElement): void => {
    if (el.style.backgroundImage) return;
    const bg = pickLazyBg(el);
    if (bg) {
        el.style.backgroundImage = `url('${bg}')`;
    }
};

export const initLazyBackgrounds = (): void => {
    const elements = document.querySelectorAll<HTMLElement>('.lazy-bg[data-bg]');
    if (!elements.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                applyLazyBg(entry.target as HTMLElement);
                obs.unobserve(entry.target);
            }
        }
    }, { rootMargin: '200px 0px' });

    elements.forEach(el => observer.observe(el));
};
